var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("inactive-loader")
    : _c(
        "div",
        {
          staticClass: "container-fluid",
          attrs: { id: "client-profiles-inactive" },
        },
        [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c(
              "div",
              { staticClass: "col-12 px-md-5" },
              [
                _c("page-header", {
                  attrs: {
                    title: _vm.$tc("inactive-clients.inactiveClient", 2),
                    subtitle: _vm.$t("inactive-clients.subtitle"),
                  },
                }),
                _vm._v(" "),
                _c("inactive-actions", {
                  attrs: { "search-string": _vm.searchString },
                  on: { "inactive-search": _vm.searchClients },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "position-relative" },
                  [
                    _c("inactive-table", {
                      attrs: {
                        "table-name": "inactive",
                        clients: _vm.currentInactive,
                      },
                      on: {
                        reactivate: _vm.showReactivateClientModal,
                        sort: _vm.handleSort,
                        "update-board": _vm.handleUpdate,
                      },
                    }),
                    _vm._v(" "),
                    _vm.loadTable
                      ? _c("div", { staticClass: "overlay clear w-100 h-100" })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.loadingMore ? _c("div", [_c("load-more")], 1) : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("reactivate-modal", {
            ref: "reactivateClientModal",
            attrs: {
              "client-profile-id": _vm.reactiveClientProfile.id,
              "board-id": _vm.reactiveClientProfile.boardId,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }